// extracted by mini-css-extract-plugin
export default {"rightPanelContent":"VisualDescriptionLoader-module__rightPanelContent_cwkU2","placeholder":"VisualDescriptionLoader-module__placeholder_DM4e0"};